import { useState } from "react";
import { Link } from "react-router-dom";
import { articles, categories } from "@/mocks/articles";
import ArticleCard from "@/components/base/ArticleCard";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const featuredArticles = articles.filter((a) => a.featured);
const hotArticles = articles.filter((a) => a.hot).slice(0, 6);
const latestArticles = [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, 12);

export default function Home() {
  const [activeTab, setActiveTab] = useState("latest");

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "51黑料吃瓜网",
    url: "https://hzljbj.cn",
    description: "51黑料吃瓜网 - 国内领先的娱乐资讯聚合平台，实时推送今日黑料、最新爆料和吃瓜内容，覆盖黑料吃瓜、娱乐八卦等每日更新。",
    contactPoint: {
      "@type": "ContactPoint",
      email: "contact@51heiliao.com",
      contactType: "customer service",
    },
  };

  const webSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "51黑料吃瓜网",
    url: "https://hzljbj.cn",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://hzljbj.cn/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero */}
          <section className="relative pt-16">
            <div className="relative h-[420px] md:h-[520px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20bold%20dramatic%20dark%20background%20with%20warm%20crimson%20and%20amber%20abstract%20gradient%20waves%2C%20modern%20minimalist%20design%2C%20no%20text%2C%20smooth%20flowing%20shapes%2C%20entertainment%20news%20atmosphere%2C%20cinematic%20lighting%2C%20dark%20elegant%20composition&width=1400&height=520&seq=hero-bg-01&orientation=landscape"
                alt="51黑料吃瓜网 - 今日黑料首页"
                className="w-full h-full object-cover object-top"
                title="51黑料吃瓜网 - 今日黑料首页"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
                <h1 className="font-heading text-3xl md:text-5xl text-background-50 mb-3">
                  51黑料吃瓜网
                </h1>
                <p className="text-base md:text-lg text-background-200 max-w-2xl leading-relaxed">
                  实时推送今日黑料、最新爆料和吃瓜内容，覆盖黑料吃瓜、娱乐八卦等每日更新，即点即看
                </p>
                <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
                  <Link
                    to="/category/all"
                    className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
                  >
                    立即吃瓜
                  </Link>
                  <Link
                    to="/about"
                    className="px-6 py-2.5 bg-background-50/20 text-background-50 border border-background-50/30 rounded-full text-sm font-medium hover:bg-background-50/30 transition-colors whitespace-nowrap"
                  >
                    了解更多
                  </Link>
                </div>
              </div>
            </div>
          </section>

          {/* Category Navigation */}
          <section className="w-full px-4 md:px-6 py-8">
            <div className="flex items-center gap-3 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={cat.id === "all" ? "/" : `/category/${cat.slug}`}
                  className="flex items-center gap-1.5 px-4 py-2 rounded-full border border-background-200/70 text-sm text-foreground-700 hover:text-primary-500 hover:border-primary-300 hover:bg-primary-50 transition-all whitespace-nowrap"
                >
                  <i className={`${cat.icon} text-sm`} />
                  {cat.name}
                </Link>
              ))}
            </div>
          </section>

          {/* Featured Articles */}
          <section className="w-full px-4 md:px-6 pb-8">
            <div className="flex items-center justify-between mb-5">
              <h2 className="font-heading text-xl md:text-2xl text-foreground-900 flex items-center gap-2">
                <i className="ri-fire-line text-accent-500" />
                重磅爆料
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {featuredArticles.slice(0, 6).map((article, idx) => {
                const cat = categories.find((c) => c.id === article.category);
                return (
                  <ArticleCard
                    key={article.id}
                    id={article.id}
                    title={article.title}
                    slug={article.slug}
                    excerpt={article.excerpt}
                    category={article.category}
                    categoryName={cat?.name || article.category}
                    date={article.date}
                    views={article.views}
                    image={article.image}
                    featured={idx === 0}
                    size={idx === 0 ? "large" : "small"}
                  />
                );
              })}
            </div>
          </section>

          {/* Hot Now */}
          <section className="w-full px-4 md:px-6 pb-8 bg-background-100 py-8">
            <div className="flex items-center gap-3 mb-5">
              <h2 className="font-heading text-xl md:text-2xl text-foreground-900 flex items-center gap-2">
                <i className="ri-flashlight-line text-primary-500" />
                热搜榜
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {hotArticles.map((article) => {
                const cat = categories.find((c) => c.id === article.category);
                return (
                  <ArticleCard
                    key={article.id}
                    id={article.id}
                    title={article.title}
                    slug={article.slug}
                    excerpt={article.excerpt}
                    category={article.category}
                    categoryName={cat?.name || article.category}
                    date={article.date}
                    views={article.views}
                    image={article.image}
                  />
                );
              })}
            </div>
          </section>

          {/* Latest Updates */}
          <section className="w-full px-4 md:px-6 py-8">
            <div className="flex items-center justify-between mb-5">
              <h2 className="font-heading text-xl md:text-2xl text-foreground-900 flex items-center gap-2">
                <i className="ri-timer-line text-secondary-500" />
                最新更新
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {latestArticles.map((article) => {
                const cat = categories.find((c) => c.id === article.category);
                return (
                  <ArticleCard
                    key={article.id}
                    id={article.id}
                    title={article.title}
                    slug={article.slug}
                    excerpt={article.excerpt}
                    category={article.category}
                    categoryName={cat?.name || article.category}
                    date={article.date}
                    views={article.views}
                    image={article.image}
                  />
                );
              })}
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}